export const TURNSTILE_SITE_KEY = "0x4AAAAAADvkbPaRTMVugQMv";
